import { Navigate, useRoutes } from "react-router-dom";
// pages
import { BASE_URL, PATH_PAGE } from "./paths";
import HomePage from "../pages/homepage/HomePage";
import ContactPage from '../pages/ContactPage';
import PrivacyPage from '../pages/PrivacyPage';
import TermsPage from '../pages/TermsPage';

// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    {
      path: BASE_URL,
      element: <HomePage />,
    },
    { path: PATH_PAGE.privacy, element: <PrivacyPage /> },
    { path: PATH_PAGE.terms, element: <TermsPage /> },
    { path: PATH_PAGE.contact, element: <ContactPage /> },
    // {
    //   path: PATH_BLOG.blog,
    //   children: [
    //     { element: <BlogPostsPage />, index: true },
    //     { path: PATH_BLOG.post.root, element: <BlogPostPage /> },
    //   ],
    // },

    // {
    //   element: <CompactLayout />,
    //   children: [{ path: `${BASE_URL}/404`, element: <Page404 /> }],
    // },
    { path: `${BASE_URL}/*`, element: <Navigate to={`${BASE_URL}`} /> },
    { path: '/*', element: <Navigate to={`${BASE_URL}`} /> },
    { path: '/', element: <Navigate to={BASE_URL} /> },
  ]);
}
